import { render, staticRenderFns } from "./PolicyProductCard.vue?vue&type=template&id=6bdea50e&scoped=true"
import script from "./PolicyProductCard.vue?vue&type=script&lang=ts"
export * from "./PolicyProductCard.vue?vue&type=script&lang=ts"
import style0 from "./PolicyProductCard.vue?vue&type=style&index=0&id=6bdea50e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bdea50e",
  null
  
)

export default component.exports